// material-ui
import {useTheme} from '@mui/material/styles';
import {ThemeMode} from "../../config";
import * as React from "react";
import {useHistory} from "react-router-dom";
import {useMultilingualText} from "../../../../hooks/useMultilingualText";
import {IMAGE_LOGO} from "../../../../assets/images";
import {getRouteUrl} from "../../../../helpers/getRouteUrl";
import {ROUTE_PAGE_HOME} from "../../../../routers/routes";

// project-import

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoMain = (props) => {
   /* const theme = useTheme();
    return (
        /!**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="Mantis" width="100" />
         *
         *!/
        <></>
    );
};*/

    const history = useHistory()
    const imageUrl = useMultilingualText(IMAGE_LOGO)
    return (
        <>
            <img
                onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME))}
                src={imageUrl}
                alt="logo"
                style={
                    {
                        marginRight: 2,
                        maxWidth: 120,
                       // maxHeight: 50,
                        cursor: "pointer"
                    }
                }
            />
        </>
    )
};

// LogoMain.propTypes = {
//   reverse: PropTypes.bool
// };

export default LogoMain;
